function getInternalKeyForFavouriteDescriptor(descriptor) {
  switch (descriptor?.type) {
    case "course":
      return `${descriptor.courseId}-${descriptor.revisionId}`;
    case "page":
      return descriptor.pageId;
    default:
      return "";
  }
}

export { getInternalKeyForFavouriteDescriptor };
//# sourceMappingURL=util.get-internal-key.js.map
